import { prop } from "ramda";
import { createSelector } from "reselect";
import {
  ATTACHMENT_CALL_STATE_IDENTIFIER,
  ATTACHMENT_CALL_STATE_IDENTIFIER_SAVE,
  CANCEL_TAKE_CHARGE_TASK_CALL_STATE,
  SELECTED_TASK_IDENTIFIER,
  SELECTED_TASK_TMP_ATTRIBUTES,
  TASK_DETAIL_IDENTIFIER,
  TASK_DETAIL_LOADER_IDENTIFIER,
  TASK_LIST_IDENTIFIER,
  TASK_LIST_LOADER,
  CSV_TASK_LIST_IDENTIFIER,
  TASK_MAIN_CALL_STATE,
  CSV_TASK_LOADED_IDENTIFIER,
} from "./constants";

const taskManagementState = (state: any) => state.taskManagement;

const formState = (state: any) => state.form;

export const csvTaskList: any = createSelector(
  taskManagementState,
  prop(CSV_TASK_LIST_IDENTIFIER)
);

export const csvTaskLoaded: any = createSelector(
  taskManagementState,
  prop(CSV_TASK_LOADED_IDENTIFIER)
);

export const taskList: any = createSelector(
  taskManagementState,
  prop(TASK_LIST_IDENTIFIER)
);

export const selectTaskListLoader: any = createSelector(
  taskManagementState,
  prop(TASK_LIST_LOADER)
);

export const selectedTask: any = createSelector(
  taskManagementState,
  prop(SELECTED_TASK_IDENTIFIER)
);

export const selectTaskMainCallState: any = createSelector(
  taskManagementState,
  prop(TASK_MAIN_CALL_STATE)
);

export const selectTaskDetail: any = createSelector(
  taskManagementState,
  prop(TASK_DETAIL_IDENTIFIER)
);

export const selectSelectedTaskTmpAttributes: any = createSelector(
  taskManagementState,
  prop(SELECTED_TASK_TMP_ATTRIBUTES)
);

export const selectTaskDetailLoader: any = createSelector(
  taskManagementState,
  prop(TASK_DETAIL_LOADER_IDENTIFIER)
);

export const selectFormTaskValues: any = createSelector(
  formState,
  prop("TasksFormFilter")
);

export const selectTaskMainCallStateTakeCharge: any = createSelector(
  taskManagementState,
  prop(CANCEL_TAKE_CHARGE_TASK_CALL_STATE)
);

export const selectAttachmentsCallState: any = createSelector(
  taskManagementState,
  prop(ATTACHMENT_CALL_STATE_IDENTIFIER)
);

export const selectAttachmentsCallStateSave: any = createSelector(
  taskManagementState,
  prop(ATTACHMENT_CALL_STATE_IDENTIFIER_SAVE)
);
